<template>

		<b-card class="table-paginator" no-body>

			<template v-slot:header>
				<b-row>

					<b-col>
						<h6 class="mb-0"><i class='fa fa-align-justify'></i> {{caption}}</h6>
					</b-col>

					<b-col lg=2 md=3 sm=4 class="align-right" v-if="newItemName.length">
						<router-link class="btn-link" :to="newItem">
							<i class='fa fa-plus'></i>	Nuevo
						</router-link>
					</b-col>
					
				</b-row>
			</template>


			<spinner v-if="loading"/>


			<template v-else>

				<b-table responsive class="animated fadeIn" :dark="dark" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" :items="items" :fields="captions" :per-page="perPage">

					<template #cell(foto)="data">
						<api-img :comp="data.value" :rowed="true" />
					</template>

					<template #cell(imagenes_id)="data">
						<api-img :comp="data.value" :rowed="true" />
					</template>
					
					<template #cell(imagenes_id_logo)="data">
						<api-img :comp="data.value" :rowed="true" />
					</template>

					<template #cell(imagenes_id_avatar)="data">
						<api-img :comp="data.value" :rowed="true" />
					</template>

					<template #cell(imagen_id)="data">
						<api-img :comp="data.value" :rowed="true" />
					</template>

					<template #cell(avatar)="data">
						<api-img :comp="data.value" :rowed="true" />
					</template>

					<template #cell(total)="data">
						{{data.value | currency}}
					</template>

					<template #cell(ventas)="data">
						{{data.value | currency}}
					</template>

					<template #cell(utilidad)="data">
						{{data.value | currency}}
					</template>

					<template #cell(monto)="data">
						{{data.value | currency}}
					</template>

					<template #cell(saldo)="data">
						{{data.value | currency}}
					</template>

					<template #cell(created)="data">
						{{data.value | humanizar_fecha}}
					</template>
					
					<template #cell(cierre)="data">
						{{data.value | humanizar_fecha}}
					</template>

					<template #cell(fecha)="data">
						{{data.value | humanizar_fecha_simple}}
					</template>

					<template #cell(modified)="data">
						{{data.value | humanizar_fecha}}
					</template>

					<!-- TOOLING -->
					<template	#cell(_)="data">
						<router-link :to="composeEditUri(data.item)" class="btn btn-primary btn-sm btn-primary">
								Detalle
						</router-link>
					</template>

				</b-table>

				<nav class="pb-1">
					<b-pagination v-model="currentPage"	:total-rows="itemsCount" :per-page="perPage" 
						align="center"
						prev-text="Anterior"
						next-text="Siguiente" />
				</nav>

				<hr>
				
				<p class="text-center pt-3">
					<strong>Página {{currentPage}} de {{Math.ceil(itemsCount / perPage)}}</strong> (Se muestran <strong>{{items.length}} registros</strong> de un total de {{itemsCount}})
				</p>

			</template>


		</b-card>
		
</template>

<script>

	import apiImg from '@/views/elements/api-img'
	import axios from 'axios'

	export default {
		name: 'table-paginator',
		inheritAttrs: false,
				components: {
				apiImg
			},
		props: {
			newItemName: {
				String,
				default: ''
			},
			editName: {
				String,
				default: ''
			},
			caption: {
				type: String,
				default: 'Table'
			},
			hover: {
				type: Boolean,
				default: false
			},
			striped: {
				type: Boolean,
				default: false
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			},
			tableUri: {
				type: String,
				default: () => ''
			},
			fields: {
				type: [Array, Object],
				default: () => []
			},
			avatarKeyName: {
				type: String,
				default: 'imagenes_id'
			},
			perPage: {
				type: Number,
				default: 25
			},
			dark: {
				type: Boolean,
				default: false
			}
		},
		data: () => {
			return {
				currentPage: 1,
				items: [],
				itemsCount: 0,
				loading: false
			}
		},
		computed: {
			captions: function() { return this.fields },
			newItem(){
				return {
					name: this.newItemName
				}
			}
		},
		mounted(){
			this.refresh()
		},
		methods: {
			composeEditUri(item){
				return {
					name: this.editName,
					params: item
				}
			},
			refresh(){
				this.items = []
				this.loading = true
				setTimeout( ()=> {
					axios.get(this.tableUri + "/" + this.perPage + "/" + this.currentPage).then(response => {
						this.items = response.data.rows
						this.itemsCount = response.data.count
						this.loading = false
					})
				}, 500)
			}
		},
		watch: {
			'tableUri' (a, b) {
				this.refresh()
			},
			'currentPage' (a, b) {
				this.refresh()
			}
		}
	}
</script>

<style lang="less">
.table-paginator {
	.align-right {
		display: block;
		text-align: right;
		a {
			text-decoration: none;
		}
	}
}
</style>